import React from 'react';
import { cn } from "../../lib/utils";
import { AlertCircle, CheckCircle, X, Info } from 'lucide-react';

const Alert = React.forwardRef(({ className, variant = "default", children, onClose, ...props }, ref) => {
  const variants = {
    default: "bg-gray-100 text-gray-900 border-gray-200",
    error: "bg-red-100 text-red-900 border-red-200",
    warning: "bg-yellow-100 text-yellow-900 border-yellow-200",
    success: "bg-green-100 text-green-900 border-green-200",
    info: "bg-blue-100 text-blue-900 border-blue-200"
  };

  const icons = {
    default: Info,
    error: AlertCircle,
    warning: AlertCircle,
    success: CheckCircle,
    info: Info
  };

  const Icon = icons[variant];

  return (
    <div
      ref={ref}
      role="alert"
      className={cn(
        "relative w-full rounded-lg border p-4 mb-4",
        variants[variant],
        className
      )}
      {...props}
    >
      <div className="flex items-start gap-4">
        {Icon && <Icon className="h-5 w-5 mt-0.5 flex-shrink-0" />}
        <div className="flex-1">{children}</div>
        {onClose && (
          <button
            onClick={onClose}
            className="ml-auto flex h-6 w-6 items-center justify-center rounded-full opacity-50 ring-offset-background transition-opacity hover:opacity-100"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Close</span>
          </button>
        )}
      </div>
    </div>
  );
});

Alert.displayName = "Alert";

const AlertTitle = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("mb-1 font-medium leading-none tracking-tight", className)}
    {...props}
  />
));

AlertTitle.displayName = "AlertTitle";

const AlertDescription = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-sm [&_p]:leading-relaxed", className)}
    {...props}
  />
));

AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };